function Navigation({ navlist, navigationlist }) {
    return (
        <>
            <ul className="nav">

                {
                    navigationlist.map((manulist) => {
                        return (
                            <>
                                <li className="nav-item" onClick={() => navlist(manulist)}>
                                    <a className="nav-link" href="#">{manulist}</a>
                                </li>
                            </>
                        )
                    })
                }


            </ul>
        </>
    )
}

export default Navigation;